import { render, staticRenderFns } from "./BuildingShow.vue?vue&type=template&id=63b5a380"
import script from "./BuildingShow.vue?vue&type=script&lang=ts"
export * from "./BuildingShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports